import { z } from 'zod'
import {
    paginationLinksSchema,
    paginationMetaSchema,
} from '@/lib/schema/v1/pagination'

export const ticketDepartmentSchema = z.object({
    created_at: z.coerce.date(),
    description: z.string().nullable(),
    name: z.string(),
    priority: z.number(),
    title: z.string(),
    updated_at: z.coerce.date(),
    uuid: z.string().uuid(),
})

export const ticketDepartmentsSchema = z.array(ticketDepartmentSchema)

export const paginatedTicketDepartmentsSchema = z.object({
    data: ticketDepartmentsSchema,
    links: paginationLinksSchema,
    meta: paginationMetaSchema,
})

export const ticketDepartmentUpdateFormSchema = z.object({
    ticket_uuid: z.string().uuid(),
    title: z.string(),
    parent_uuid: z.string().uuid().nullable(),
})

export type TicketDepartmentUpdateForm = z.infer<
    typeof ticketDepartmentUpdateFormSchema
>
